module.exports["infoButton"] = "_infoButton_5fe740";